import React, { useState } from 'react';

const messages = {
  Mentor: "Let's fix your bugs! 🐛",
  Challenge: "Swipe to practice! 💪",
  Insights: "Here's what I remember! 🧠",
};

export default function Mascot({ activeTab }) {
  const [showBubble, setShowBubble] = useState(true);

  return (
    <div
      className="mascot-wrapper"
      onClick={() => setShowBubble(!showBubble)}
    >
      {showBubble && (
        <div className="mascot-bubble">
          {messages[activeTab]}
        </div>
      )}
      <span className="mascot">🤖</span>
    </div>
  );
}